import React from 'react';

import CliveMarkdownDisplay from '~/components/Clive/CliveMarkdownDisplay/CliveMarkdownDisplay';
import CollapsibleWrapper from '~/components/core/Collapsible/CollapsibleWrapper';

import type { SopConfigurationResponse } from './types';

interface SopViewDialogContentProps {
  configuration: SopConfigurationResponse;
}

const SopViewDialogContent: React.FC<SopViewDialogContentProps> = ({ configuration }) => {
  const combinedMarkdownPages = configuration.markdown_pages?.join('\n\n---\n\n') || '';
  const tocMarkdown = configuration.toc_markdown || '';
  const pageCount = configuration.metadata?.page_count || configuration.markdown_pages?.length || 0;

  return (
    <div className="p-24">
      <div className="mb-16">
        <CollapsibleWrapper
          noBorderLine
          title={`SOP Content (${pageCount} pages)`}
          defaultState={true}
          summarySectionClassname="flex flex-row"
        >
          <div className="max-h-[400px] overflow-y-auto rounded border border-slate-200 p-16">
            <CliveMarkdownDisplay content={combinedMarkdownPages} />
          </div>
        </CollapsibleWrapper>
      </div>

      <CollapsibleWrapper
        noBorderLine
        title="Table of Contents"
        defaultState={false}
        summarySectionClassname="flex flex-row"
      >
        <div className="max-h-[400px] overflow-y-auto rounded border border-slate-200 p-16">
          <CliveMarkdownDisplay content={tocMarkdown} />
        </div>
      </CollapsibleWrapper>
    </div>
  );
};

export default SopViewDialogContent;
